module.exports = __webpack_public_path__ + "static/bg-21313eba02c711d20e72aca6789da5ce.jpg";